// Source of truth for reusable/savable payment methods in Stripe Payment Element:
// - https://docs.stripe.com/payments/save-customer-payment-methods
// - https://docs.stripe.com/payments/payment-methods/payment-method-support
// Keep this list aligned with Stripe's currently supported saved payment methods.
export enum STRIPE_PAYMENT_METHOD_TYPES_SUPPORTING_SAVE {
    card = 'card',
    usBankAccount = 'us_bank_account',
    acssDebit = 'acss_debit',
    sepaDebit = 'sepa_debit',
    bacsDebit = 'bacs_debit',
    auBecsDebit = 'au_becs_debit',
    nzBankAccount = 'nz_bank_account',
}
